<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card" v-if="company">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Company Volume Graph'}}</strong>
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link
              class="btn btn-sm btn-small btn-secondary"
              :to="{name: 'pTrends', props: { isIndividual: 0 } }"
            >
              <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a
              class="btn btn-sm btn-small btn-warning"
              @click.prevent="viewCalculatedData(company)"
            >
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(company)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompRawData"
            >
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
      </div>
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="'BSE'">
          <volumeGraph
            :graphData="rawData"
            :company="selComp"
            :type="selTab"
            v-if="selTab==='BSE'"
          ></volumeGraph>
        </v-tab>
        <v-tab :title="'NSE'">
          <volumeGraph
            :graphData="rawData1"
            :company="selComp"
            :type="selTab"
            v-if="selTab==='NSE'"
          ></volumeGraph>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import volumeGraph from "@/views/company/company-price-graph/volumeGraph.vue";

export default {
  // props: ["company"],
  components: { volumeGraph },
  mixins: [commonMixins],
  created() {
    this.getCompaniesList();
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      this.selTab = newTab.title;
      if (tabIndex === 0) {
        this.rawDataApi = "price_bse";
      } else if (tabIndex === 1) {
        this.rawDataApi = "price_nse";
      }
      this.rawData = {data: [], company: this.selComp};        
      this.rawData1 = {data: [], company: this.selComp};
      this.getRawData();
    },
    getRawData() {
      if (this.selComp !== "") {
        this.isChartdataLoading = 1;
        http.post(
          "rawDataList",
          {rowFieldName: this.rawDataApi, co_code: this.selComp.co_code},
          (error, response) => {
            this.isChartdataLoading = 0;
            console.log("chartdata", response);
            if (response.data.length > 0) {
              if(this.selTab === 'BSE'){
              this.rawData = { data: response.data, company: this.selComp };
              } else {
              this.rawData1 = { data: response.data, company: this.selComp };
              }
            }
          }
        );
      }
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          console.log("Selected Comp", typeof _this.selComp);
          // setTimeout(() => {
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code;
          // });
        }
      });
    },
    getCompRawData() {
      console.log("Get RawData", this.selComp);
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        this.company.companyname = this.selComp.companyname;
        this.company.co_code = this.selComp.co_code;
        console.log(
          "Company",
          this.company.co_code,
          "=>",
          this.company.companyname
        );
        // this.getTabData(this.selRowInd, {}, {});
        this.getRawData();
      }
    }
  },
  data() {
    return {
      selTab: "",
      rawDataApi: "price_bse",
      rawData: [],
      rawData1: [],
      companyList: [],
      selComp: "",
      company: { co_code: "", companyname: "" }
    };
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/companyVolumeGraph.vue